export default "__VITE_ASSET__Cq$OcSfO__"